import React, { useState } from 'react';
import { PieChart as MuiPieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { Icon } from '@iconify/react';
import Stack from '@mui/material/Stack';

function PieChart({ data }) {
    const [currentPage, setCurrentPage] = useState(0);
    const legendsPerPage = 2;

    const visibleLegends = data.slice(currentPage * legendsPerPage, (currentPage + 1) * legendsPerPage);

    const handlePreviousPage = () => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if ((currentPage + 1) * legendsPerPage < data.length) {
            setCurrentPage(currentPage + 1);
        }
    };

    return (
        <div className="pieChart">
            <MuiPieChart
                series={[
                    {
                        arcLabel: (item) => `${item.value}%`,
                        arcLabelMinAngle: 45,
                        data,
                    },
                ]}
                sx={{
                    [`& .${pieArcLabelClasses.root}`]: {
                        fill: 'white',
                        fontWeight: 'bold',
                        fontSize:'12px'
                    },
                }}
                width={400}
                height={270}
                slotProps={{ legend: { hidden: true } }}
                margin={{ left: 80, right: 80 }}
            />
            <Stack direction="row" spacing={1} style={{ justifyContent: 'center' }}>
                <Icon
                    icon="grommet-icons:form-previous"
                    onClick={handlePreviousPage}
                    className='next-privious-icon'
                    style={{ opacity: currentPage === 0 ? 0.5 : 1 }}
                />
                {visibleLegends.map((item) => (
                    <div key={item.id} style={{ display: 'flex', alignItems: 'center' }} className='pie-chart-legend' title={item.label}>
                        <div
                            style={{
                                width: '10px',
                                height: '10px',
                                backgroundColor: item.color,
                                marginRight: '5px',
                            }}
                        />
                        <span title={item.label}><small>{`${item.label.substring(0, 6)}...`}</small></span>
                    </div>
                ))}
                <Icon
                    icon="mdi:navigate-next"
                    onClick={handleNextPage}
                    className='next-privious-icon'
                    style={{ opacity: (currentPage + 1) * legendsPerPage >= data.length ? 0.5 : 1 }}
                />
            </Stack>
        </div>
    );
}

export default PieChart;
